import React from 'react';
import ReactDOM from 'react-dom';
import './episodes.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";


/* ---------------------RESOURCES--------------------- */
class Ep extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="longerPage container-fluid">
                <span class="topButtons"><button className="eButton"><Link to="/Episodes">Episodes</Link></button><button className="hButton"><Link to="/">Home</Link></button></span>

                
                {/*Titles*/}
                <div className="row">
                    <div className="title-wrapper col-12">
                        <h1 className="title">Season 2, Episode 7: Liberation Day and Japanese Imperialism</h1>
                        <h5 className="korean-title">시즌 2, 에피소드 7: 광복절</h5>
                    </div>
                </div>
                {/*VOCABULARY*/}
                <div class="vocabList">
<div class="vocabList">
<span class="italics">Listen to the episode <a target="_blank" href="https://anchor.fm/learn-korean-culture/episodes/S2--Episode-7-Liberation-Day-and-Japanese-Imperialism-e15aoac">here</a>!</span> <br></br>
</div>
<br></br>


{/* INTRO */}
이름 (eeh reum) — name <br></br>
바뀌다 (bah qqi da) — to change <br></br>
끝나다 (kkeut na da) — to end <br></br>
대한제국 (dae han jae gook) — Korean Empire that ruled from 1897 to 1910 <br></br>

<br></br>
{/* BEGINNING OF IMPERIALISM */}
러일 전쟁 (ruh il jeon jaeng) — Russo-Japan war <br></br>
한반도 (han bahn do) — Korean peninsula <br></br>
차지하다 (cha ji ha da) — to take control of <br></br>
다툼 (da toom) — fight <br></br>
시작하다 (shi jak ha da) — to begin <br></br>
전쟁 (jeon jaeng) — war <br></br>
2 달 후 (doo dal who) – 2 months after <br></br>
을사조약 (eul sah jo yak) — Japan-Korean treaty of 1905 (조약=treaty) <br></br>
국치일— National Humiliation Day, the day that the Japan-Korean Annexation Treaty was signed (August 22nd of 1910) <br></br>

<br></br>
{/* REBELLION */}
의병 (euh byeong) –  righteous armies; rebels fighting against Japanese armies to liberate Korea. <br></br>
17만명 — 17,000 people <br></br>
35만명 — 35,000 people <br></br>
부상을 입다 (boo sang eul ip da) — to be injured <br></br>

<br></br>
{/* DEATH OF ROYALS */}
년 (nyeon) — counter for years <br></br>
후 (who) — after <br></br>
고종 (go jong) — second to last emperor of the Korean empire before the Japanese took control of Korea  <br></br>
덕수궁 (duk soo goong) — the palace where the royal family used to live
많은 사람들 (man eun sah ram deul) — many people <br></br>
살해 (sal hae) — killing <br></br>

<br></br>
{/* MARCH 1st */}
3.1 운동 (sam il oon dong) — March 1st movement (pictured below) <br></br>
<img className="epPic" src="https://www.kocis.go.kr/CONTENTS/editImage/20190408140035446_1.jpg"></img><br></br>
<br></br>
비폭력 (bi pok ryeok) — nonviolent <br></br>
만세 (man sae) — hurrah (used to advocate for something, so here it would be Korean independence) <br></br>
운동 (oon dong) — movement <br></br>
한일 병합 조약 (han il byeong hap jo yak) – Japan-Korea treaty of 1910 <br></br>
무효 (moo hyo) — invalidity <br></br>
한국 독립 (han gook dok rip) — Korean independence <br></br>
선언하다 (seon un ha da) — to declare/advocate <br></br>
106만여 명 — around 106,000 people <br></br>
모이다 (mo eeh da) — to gather <br></br>
죽다 (jook da) — to die <br></br>

<br></br>
{/* REBELLIONS*/}
청산리 전투 (chung san li jeon too) — Battle of Qingshanli (청산리 is the Korean pronunciation of Qingshanli and 전투 means battle) <br></br>
독립 (dok lip) —independence <br></br>
투쟁 (too jaeng) — fight <br></br>
활발해진다 (hwal bal hae jin da) — to become more active <br></br>
민병 (min byeong) — civilian soldiers or fighters <br></br>

6.10 만세운동 — June 10th movement  <br></br>
<img className="epPic" src="https://image.ajunews.com/content/image/2020/12/08/20201208143244546094.jpg"></img><br></br>
<br></br>
운동 (oon dong) — movement <br></br>
특이한 점 (teuk eeh han jum) — interesting point <br></br>
학생 (hak saeng) — student <br></br>
중심 (joong shim) — center <br></br>
일어나다 (il uh na da) — rise <br></br>
독립운동 (dok lip eun dong) — independence movement <br></br>
조선독립만세 (jo seon dok lip man sae) — Hurray for Independent Joseon! <br></br>

<br></br>
{/* CULTURAL POLICY AND CONCLUSION */}
창씨개명 (chang ssi gae myeong) — cultural policy forcing Koreans to adopt Japanese names instead <br></br>
이름 (eeh reum) — name <br></br>
2차 (eeh cha) — second <br></br>
세계 (sae gae) — world <br></br>
항복하다 (hahng bok ha da) — to surrender <br></br>




                </div>
                <div className="row"><div className="col-12 spacer5"></div></div>
            </div>


        )
    }
}


/* -------------------------Variables------------------------- */
function App() {
    return (
        <div>
        <Ep></Ep>
        </div>
    );
}


  const Episode = () => (
    <div className='app'>
        <App />
    </div>
  );


export default Episode;